
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/search",
      function () {
        return require("private-next-pages/en/search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/search"])
      });
    }
  